module.exports = __webpack_public_path__ + "img/home_lottery_type4.5a4fe93f.png";